const ChatMessage = ({ role, content, sources, pending }) => {
  const isUser = role === "user";

  const safeContent =
    typeof content === "string" || typeof content === "number"
      ? String(content)
      : content == null
        ? ""
        : JSON.stringify(content, null, 2);

  const sourceList = Array.isArray(sources) ? sources : [];

  return (
    <div className={`flex w-full items-start gap-2 ${isUser ? "justify-end" : "justify-start"}`}>
      {!isUser && (
        <div
          className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-primary text-primary-content text-xs font-bold"
          title="AI"
        >
          AI
        </div>
      )}
      <div
        className={`max-w-[85%] rounded-2xl px-4 py-3 ${
          isUser
            ? "bg-primary text-primary-content"
            : "bg-base-200 text-base-content"
        }`}
      >
        {!isUser && pending ? (
          <div className="mt-2 flex items-center gap-2 text-xs text-base-content/70">
            <span className="loading loading-spinner loading-xs" />
            <span>Finding Answer......</span>
          </div>
        ) : (
          <>
            <div className="whitespace-pre-wrap break-words text-sm">
              {safeContent}
            </div>
          </>
        )}

        {!isUser && !pending && sourceList.length > 0 && (
          <details className="mt-3 border-t border-base-300 pt-2">
            <summary className="cursor-pointer text-xs font-semibold text-primary">
              Sources (Top {sourceList.length} chunks)
            </summary>
            <ul className="mt-2 space-y-2 text-xs">
              {sourceList.slice(0, 3).map((chunk, i) => (
                <li
                  key={i}
                  className="rounded border border-base-300 bg-base-100 p-2"
                >
                  {typeof chunk === "string" ? chunk : chunk?.text ?? JSON.stringify(chunk)}
                </li>
              ))}
            </ul>
          </details>
        )}
      </div>
      {isUser && (
        <div
          className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-base-300 text-base-content text-xs font-bold"
          title="User"
        >
          U
        </div>
      )}
    </div>
  );
};

export default ChatMessage;
